import React from 'react';
import MaterialSelector from '../materialSelector';
import SizeSelector from '../sizeSelector';
import { ProductPurchaseSelectorsProps } from '../interfaces';

import './ProductPurchaseSelectors.scss';

const ProductPurchaseSelectors: React.FC<ProductPurchaseSelectorsProps> = ({
  productId,
  selectedSize,
}) => (
  <>
    <MaterialSelector itemId={productId} dataSource="product" />
    <SizeSelector itemId={productId} selectedSize={selectedSize ?? ''} dataSource="product" />
  </>
);

export default ProductPurchaseSelectors;
